import type { CognitoUser } from '../../interfaces/cognitoUser';
import type { SerializableAuthUser } from '../../interfaces/authUser';

export function toSerializableAuthUser(
    user: CognitoUser
): SerializableAuthUser {
    const groups =
        user.signInUserSession?.accessToken?.payload?.['cognito:groups'] ?? [];

    return {
        email: user.attributes?.email ?? '',
        groups,
        username: user.username
    };
}
